import RelatorioUsuario from "@/domain/conta/usuario/RelatorioUsuario.js";
import Table from "./Table";
export default class TableRelaUsuarios extends Table {
    constructor() {
        super();
    }

    getHeaders() {
        var headers;
        headers = [
            { text: "Nome", value: "rela_nome", show: true, pesq: true, enable: true },
            { text: "Sobrenome", value: "rela_sobrenome", show: true, pesq: false, enable: true },
            { text: "Data de Registro", value: "rela_dtReg", show: true, pesq: false, enable: true },
            { text: "Data do Último Acesso", value: "rela_dtLastLogin", show: true, pesq: false, enable: true },
            { text: "Total de Acessos", value: "rela_qntLogins", show: true, pesq: false, enable: true },
            { text: "E-mail", value: "rela_email", show: true, pesq: true, enable: true },
            { text: "Telefone", value: "rela_telefone", show: true, pesq: false, enable: true },
            { text: "Empresa Faturamento", value: "rela_faturaRazao", show: true, pesq: false, enable: true },
            { text: "Lista de Acesso", value: "rela_arrayLogins", show: false, pesq: false, enable: false },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
        ]
        return headers
    }

    setNota(arrayNotas, notas) {
        this.loading = false;

        for (var i = 0; i < notas.length; i++) {
            notas[i].dtLogin ? notas[i].dtLogin = notas[i].dtLogin.sort((a, b) => a < b ? 1 : a > b ? -1 : 0).slice() : notas[i].dtLogin = [];
            arrayNotas.push(
                new RelatorioUsuario(
                    notas[i].nome,
                    notas[i].sobrenome,
                    notas[i].dtReg,
                    notas[i].dtLogin && notas[i].dtLogin.length > 0 && notas[i].dtLogin[0] ? notas[i].dtLogin[0] : undefined,
                    notas[i].dtLogin ? notas[i].dtLogin.length : 0,
                    notas[i].email,
                    notas[i].telefone,
                    notas[i].empresa ? notas[i].empresa.razao : '-',
                    notas[i].dtLogin,
                    notas[i]._id,
                )
            );
        }
        this.pagination.sortBy = 'rela_dtLastLogin';
        this.pagination.descending = true;
        return arrayNotas
    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableRelaUsuarios.js